import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { AIAuditLogPluginState } from './types';

export const aiAuditLogsPluginKey: PluginKey<AIAuditLogPluginState> =
	new PluginKey<AIAuditLogPluginState>('aiAuditLogs');
